/** 1 acre = 43,560 sq ft (RicherValues conversion) */
export const SQFT_PER_ACRE = 43560

export const sqftToAcres = (sqft: number | string | null | undefined): string => {
  const n = parseFloat(String(sqft ?? '').replace(/,/g, ''))
  if (!Number.isFinite(n) || n <= 0) return ''
  return (n / SQFT_PER_ACRE).toFixed(2)
}

export const acresToSqft = (acres: number | string | null | undefined): string => {
  const n = parseFloat(String(acres ?? '').replace(/,/g, ''))
  if (!Number.isFinite(n) || n <= 0) return ''
  return String(Math.round(n * SQFT_PER_ACRE))
}
